import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {Link, Route, Switch, NavLink, withRouter} from "react-router-dom";
import GameComponent from "game/app/components/game/game-component";
import {Collapse, Nav, NavItem} from "reactstrap";
import VideoBtn from "game/app/components/video-btn";

class NavbarRound1 extends GameComponent {

    toggleMobile = (e) => {
        e.preventDefault();
        this.props.sidebarToggleMobile();
    };

    toggleDesktop = (e) => {
        e.preventDefault();
        this.props.sidebarToggle();
    };

    render() {
        if (!this.getInstance()) return '';

        let instanceId = this.getInstanceId();

        return (
            <div className='bottom-menu'>
                <div className='info'>Není ti jasné, jak hra probíhá? <Link to={{ pathname: `/pravidla`, state: { rules: 'secondary' }}}>Přečti si pravidla</Link>, nebo si <VideoBtn videoId='_l_4RgfShzs' btnClassName='video-link'>pusť video</VideoBtn>.</div>
                <Collapse isOpen={this.props.toggle} navbar>
                    <ul className='navbar-nav'>
                        <li className='nav-item'><Link className='nav-link' to={`/game/${instanceId}/`}>Přehled</Link></li>
                        <li className='nav-item'><NavLink className='nav-link' to={`/game/${instanceId}/round-2/rozpocet`}>Rozpočet</NavLink></li>
                        <li className='nav-item'><NavLink className='nav-link' to={`/game/${instanceId}/round-2/rodina`}>Profil</NavLink></li>
                        <li className='nav-item'><NavLink className='nav-link' to={`/game/${instanceId}/round-2/otazky`}>Úkoly</NavLink></li>
                        <li className='nav-item'><NavLink to={`/game/${this.props.gameInstance.instance.id}/round-2/finalize`} className='nav-link'>{ this.getInstanceProperty('ROUND_2_COMPLETED') ? 'Vyhodnocení' : 'Ukončit kolo' }</NavLink></li>
                        <li className='nav-item'><NavLink className='nav-link' to={`/game/${instanceId}/bonus-tasks`}>Bonusové úkoly</NavLink></li>
                    </ul>
                </Collapse>
            </div>
        )
    }
}


function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance,
        auth: state.auth,
        sidebarToggle: ownProps.sidebarToggle,
        sidebarToggleMobile: ownProps.sidebarToggleMobile,
        toggle: ownProps.toggle
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(NavbarRound1));
